@let control = ngControl.control;

<mat-form-field appearance="outline" class="rp-input" [class.filled]="control.value" [subscriptSizing]="subscriptSizing()">
  <mat-label>{{ label() }}</mat-label>

  <input
    matInput
    [mask]="mask()"
    [decimalMarker]="decimalMarker()"
    [thousandSeparator]="thousandSeparator()"
    [prefix]="prefix()"
    [allowNegativeNumbers]="allowNegativeNumbers()"
    [suffix]="suffix()"
    [type]="type()"
    [formControl]="control"
    [placeholder]="placeholder()"
    [errorStateMatcher]="matcher()"
  />

  @if (clearable() && control.value) {
    <rp-icon class="icon clickable" matSuffix [iconName]="icons.ResetFilter" size="s" (click)="onClear()" />
  }

  @if (iconName()) {
    <rp-icon class="icon" matSuffix [iconName]="iconName()" size="s" (click)="onIconAction($event)" />
  }

  @if (hint()) {
    <mat-hint mat-hint>{{ hint() }}</mat-hint>
  }

  @if ((control.invalid || (control.dirty && errors().length)) && showErrorMessage()) {
    <mat-error>{{ firstError() | translate: firstErrorKey() }}</mat-error>
  }
</mat-form-field>
